<template>
  <div>
    <hr>
    <table class="activities">
      <template v-for="entry in entries_sorted">
        <tr :class="{faded: !project ? false : project !== entry.project.identifier}" @click="loadEntry(entry._id)" v-for="day in entry.days" class="entry">
          <td class="number-font" style="white-space: nowrap; text-align: left">
            {{`${("00" + day.start.getDate()).substr(-2,2)}.${("00" + (day.start.getMonth() + 1)).substr(-2,2)}.${day.start.getFullYear()}`}}
          </td>
          <td style="white-space: nowrap; display: flex; align-items: center">
            <span class="dot" :style="{backgroundColor: entry.project.icc}"></span>&nbsp;
            {{entry.project.codename}}
          </td>
          <td style="width: 100%">{{entry.note}}</td>
          <td class="number-font" style="white-space: nowrap; text-align: right">
            {{`${('00' + day.start.getHours()).substr(-2,2)}:${('00' + day.start.getMinutes()).substr(-2,2)}`}}
          </td>
          <td class="number-font" style="white-space: nowrap; text-align: right">
            {{day.end.getHours() === 0 && day.end.getMinutes() === 0 ? '24:00' : `${('00' + day.end.getHours()).substr(-2,2)}:${('00' + day.end.getMinutes()).substr(-2,2)}`}}
          </td>
          <td class="number-font total" style="text-align: right">{{`${Math.floor(day.total)},${("00" + Math.floor((day.total - Math.floor(day.total)) * 100)).substr(-2,2)}`}}</td>
        </tr>
      </template>
    </table>
    <div class="total number-font">
      <span>{{total_display}}</span>
    </div>
    <div class="wage">EUR {{Math.floor(value)}},{{('00' + Math.floor((value - Math.floor(value))*100)).substr(-2,2)}}</div>
  </div>
</template>


<script>

export default {
  name: 'entries',
  props: {
    project: {
      type: String
    },
    track: {
      type: String
    },
    year: {
      type: Number
    },
    month: {
      type: Number
    },
    wage: {
      type: Number,
      required: false,
    }
  },
  computed: {
    value() {
      return this.total * (this.wage || 17.5);
    },
    total() {
      let sum = 0;
      for (let i = 0; i < this.entries_sorted.length; ++i) {
        sum += this.entries_sorted[i].total_number
      }
      return sum;
    },
    total_display() {
      let total_floor = Math.floor(this.total);
      return `${total_floor},${("00" + ((this.total - total_floor) * 100).toFixed(0)).substr(-2,2)}`
    },
    parsed_entries() {
      return this.$store.state.entries.map((entry, key) => {
        let project = this.$store.state.projects.filter(project => {
          return project.identifier === entry.project
        })[0];
        let start = new Date(entry.start[0], entry.start[1] - 1, entry.start[2], entry.start[3], entry.start[4], 0);
        let end = new Date(entry.end[0], entry.end[1] - 1, entry.end[2], entry.end[3], entry.end[4], 0);
        let total = Math.abs(end - start) / 36e5;
        let total_floor = Math.floor(total);

        let days = [];
        let day_crawler = new Date(entry.start[0], entry.start[1] - 1, entry.start[2], 0, 0, 0);

        while (day_crawler < end) {
          let dates = [];
          if (day_crawler < start) {
            dates[0] = start;
          } else {
            dates[0] = new Date(day_crawler.getTime());
          }
          if (day_crawler.setDate(day_crawler.getDate() + 1) < end) {
            dates[1] = new Date(day_crawler.getTime());
          } else {
            dates[1] = end;
          }

          let total = Math.abs(dates[1] - dates[0]) / 36e5;

          days.push({
            start: dates[0],
            end: dates[1],
            total: total
          });
        }

        return {
          _id: entry._id,
          date: `${("00" + entry.start[2]).substr(-2,2)}.${("00" + entry.start[1]).substr(-2,2)}.${entry.start[0]}`,
          project: project,
          note: entry.note,
          start: `${("00" + entry.start[3]).substr(-2,2)}:${("00" + entry.start[4]).substr(-2,2)}`,
          end: `${("00" + entry.end[3]).substr(-2,2)}:${("00" + entry.end[4]).substr(-2,2)}`,
          total: `${total_floor},${("00" + Math.floor((total - total_floor) * 100)).substr(-2,2)}`,
          total_number: total,
          start_date: start,
          end_date: end,
          index: key,
          days: days
        }
      })
    },
    entries_sorted() {
      function compare(a, b) {
        if (a.start_date < b.start_date) return -1;
        if (a.start_date > b.start_date) return 1;
        return 0;
      }
      return this.parsed_entries.filter(entry => {
        return (entry.end_date.getFullYear() === this.year && entry.end_date.getMonth()+1 === this.month)
          && (entry.project.track === this.track)
          && (!this.project || (this.project === entry.project.identifier));
      }).sort(compare);
    }
  },
  methods: {

    loadEntry(id) {
      this.$router.push({
        name: 'hora_entry',
        params: {
          entryId: id
        },
        query: {
          year: this.year,
          month: this.month
        }
      })
    }
  }
}
</script>


<style scoped lang="sass">
  table.activities
    margin: 1em 0
    width: 100%

    .total
      font-weight: 700

    td
      vertical-align: top
      padding-right: 1em
      padding-top: 0.5em
      padding-bottom: 0.5em

      &:last-child
        padding-right: 0

      @media screen and (max-width: 800px)
        padding: 0.5em 0

  @media screen and (max-width: 800px)
    table, tr, td
      display: block



    tr
      border-bottom: 1px solid #b8b8b8

      &:last-of-type
        border-bottom: 0
  table:hover
    tr
      filter: grayscale(1)
      opacity: 0.5
      cursor: pointer
      &:hover
        filter: none
        opacity: 1

  tr.faded
    filter: grayscale(1)
    opacity: 0.5
  span.dot
    display: inline-block
    height: 1em
    width: 1em

  div.total
    text-align: right
    margin: 1.25em 0 0.75em
    font-size: 2em
    font-weight: 700
    line-height: 0.75em
    display: block

    span
      border-bottom: 0.2em solid black

  .wage
    text-align: right
    margin: 1em 0
    font-weight: 700
    line-height: 0.75em
    font-size: 1em
    color: #8b8b8b
</style>